<template>
	<div id="appbox">
		<div class="top_heard">
			<div class="top_box" v-if="screenWidth>785">
				<div class="logo_box" @click="gohome()">
					<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;" height=""
						srcset="">
				</div>
				<div class="top_gatebox">
				

				</div>
				<div class="top_search_box">
					<div class="top_search">
						<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<!-- <i class="el-icon-search"></i> -->
						<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……"
							class="el-input__inner" style="border: 0px;width: 200px;height: 30px;">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="getlist()" alt=""
							srcset="">
					</div>

				</div>
				
			</div>
			<div class="top_tab_box">
				<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
					<template #left>
						<div class="vannav_title" style="color: #217495;font-size: 16px;" >
							研学活动
						</div>
					</template>
					<template #title>
						<div class="vannav_title" style="width: 180px;padding: 20px;">
								<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
						</div>
					</template>
				  <template #right>
					  <van-icon name="ellipsis"  size="20"    />
				  </template>
				</van-nav-bar>
				<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
					<van-picker
					  title=""
					  show-toolbar
					  :columns="vannavlist"
					  confirm-button-text="进入"
					  @confirm="vanlinkgo"
					  @cancel="vannavmenushow"
					  @change="onChange"
					/>
				</van-popup>
				<div class="toptabnav" v-if="screenWidth>785">
					<el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal"
						@select="handleSelect" router background-color="#FE7C2B" text-color="#FFFFFF"
						active-text-color="#FFFFFF">
						<el-menu-item index="/Home">首页</el-menu-item>
						<el-menu-item index="/Newslist">研学资讯</el-menu-item>
						<el-menu-item index="/Courselist">研学课程</el-menu-item>
						<el-submenu index="/institution">
							<template slot="title">研学机构</template>
							<el-menu-item index="/Camplist">研学营地</el-menu-item>
							<el-menu-item index="/Baselist">研学基地</el-menu-item>
							
						</el-submenu>

						<el-menu-item index="/Campmap">研学地图</el-menu-item>
						<el-menu-item index="/Activitylist">活动中心</el-menu-item>
						<el-menu-item index="/Linelist">研学线路</el-menu-item>
						<el-submenu index="/yanxueteam">
							<template slot="title">研学团队</template>
							<el-menu-item index="/mentorlist">研学导师</el-menu-item>
							<el-menu-item index="/expertlist">专家团队</el-menu-item>
						</el-submenu>
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
				<div class="top_banner">
					<el-carousel ref="carousel" :interval="4000" :height="screenWidth>785?'550px':(screenWidth*551/1920)+'px'" >
						<el-carousel-item v-for="item in platelist" :key="item">
							<h3 class="medium" style="width: 100%;height: 100%;"><img :src="item.thumb"
									style="width: 100%;height: 100%;" alt="" srcset="" @click="gomodules(item.link)"></h3>
						</el-carousel-item>
					</el-carousel>
				</div>
		<!-- 		<div class="top_plate">
					<div class="plate_item" v-for="(plate, index) in platelist" :key="plate"
						@mouseover="showstep(index)" @click="goplate(plate.id)">
						<div class="plate_icon">
							<img :src="plate.icon" alt="" srcset="">
						</div>
						<div class="plate_title">
							{{plate.title}}
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="mobiletype_screen"  v-if="screenWidth<785">
			<van-dropdown-menu active-color="#FE7C2B">
			  <van-dropdown-item v-model="category_id" :options="types" @change="camptypetab" />
			</van-dropdown-menu>
		</div>
		<div class="main_box" :style="screenWidth>785?'':'width:100%;'">
			<div class="screen_box"  v-if="screenWidth>785" >
				<div class="screen_items">
					<div class="screen_title_box">
						<div class="screen_title" v-for="count in typescount" :key="count">
							活动类型：
						</div>
					</div>
					<div class="" style="width: 980px;display: flex;flex-wrap: wrap;">
						<!-- 		<div   :class="region_type==''?'screen_item_a':'screen_item'"  @click="camptypetab('')" >
							全部
						</div> -->
						<div v-for="item in types" :key="item"
							:class="item.value==category_id?'screen_item_a':'screen_item'"
							@click="camptypetab(item.value)">
							{{item.text}}
						</div>
					</div>
				</div>
			</div>
			<div class="activitylist_box" :style="screenWidth>785?'':'width:calc(100% - 20px);padding:10px;zoom:'+((screenWidth/1180)*100+37)+'%'">
				<div class="activity_item" v-for="item in actlist" :key="item" @click="detail(item.id)">
					<div class="activity_img" @mouseover="showactmsg(item.id)">
						<img :src="item.icon" alt="" srcset="">
						<img src="../../../static/img/进行中.png" v-if="item.status==2" class="type_icon" alt="" srcset="">
						<img src="../../../static/img/已完成.png" v-if="false" class="type_icon" alt="" srcset="">
					</div>
					<div :class="showmsg==item.id?'activity_details activity_details_show':'activity_details activity_details_close'" @mouseleave="closeactmsg(item.id)">
						<div class="activity_details_top">
							<div class="activity_details_title">
								{{item.title}}
							</div>
							<div class="activity_msg">
								{{item.introduction||'暂无介绍'}}
							</div>
						</div>
						<div class="activity_details_bottom">
							<div class="activity_details_timer">
								<i class="el-icon-document" style="font-size: 26px;margin-right: 10px;"></i>
								{{item.start+'——'+item.end}}
							</div>
							<div class="activity_details_buttonbox">
								<div class="activity_price">
									{{'￥'+item.price}}
								</div>
								<button @click="detail(item.id)">查看详情</button>
							</div>
						</div>
					</div>
					<div class="activity_bottom">
						<div class="activity_title">
							{{item.title}}
						</div>
						<div class="Organizer">
							<div class="camp_img">
								<img src="../../../static/img/顶部搜素图标.png" alt="" srcset="">
							</div>
							<div class="Organizer_msg">
								<div class="Organizer_unit">
									{{item.unit}}
								</div>
								<div class="Organizer_subtitle">
									{{item.subtitle}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pages_total" :style="screenWidth>785?'':'padding:15px;'" >
				<el-pagination background :page-size="10" :small="screenWidth<785" :pager-count="screenWidth>785?7:5" :hide-on-single-page="true" @current-change="pagechange"
					layout="total, prev, pager, next" :total="total">
				</el-pagination>
			</div>
			<!-- 		<div class="newslist_box">
				<div class="newslist">
						<div class="newsitem" v-for="item in actlist" :key="item"  @click="detail(item.id)" >
							<div class="newsimg">
								<img :src="item.icon" alt="" srcset="">
							</div>
							<div class="newsmsg">
								<div class="newstitle" style="-webkit-box-orient:vertical;">
									{{item.title}}
								</div>
								<div class="textmsg" style="-webkit-box-orient: vertical;">
									{{item.introduction||'暂无介绍'}}
								</div>
								<div class="news_bottom">
									<div class="pageview" style="color:#f56c6c;font-size: 16px;">
										  {{item.diy_price==0&&item.is_free==0?'￥'+item.price:item.price}}
									</div>
									<div class="newstime">
										{{item.start}}
									</div>
									
								</div>
							</div>
						</div>
						
				</div>
				<div class="quicknewslist">
					<div class="quick_title">
						热门活动
					</div>
					<div class="quicknews"   >
						<div class="quick_items"   v-for="(item, index) in quicklist" :key="item" @click="detail(item.id)" @mouseenter="onitemopen(index)" >
							<img :src="item.icon"  alt="" srcset="">
							<div class="quick_msg">
								<div :class="index==newsiconon?'quick_text2':'quick_text'"   :style="index==newsiconon?'-webkit-box-orient:vertical;':''" >
									{{item.title}}
								</div>
								<div class="quick_pay">
									{{item.diy_price==0&&item.is_free==0?'￥'+item.price:item.price}}
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div> -->


		</div>
		<!-- <div class="swim_box" v-if="screenWidth>785" >
			<div class="swim_title">
				小程序查看
			</div>
			<div class="swim_code">
				<img src="https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/20230913/02119659d872e4250f8d0044f36d99a1.png"
					alt="" srcset="">
			</div>
		</div> -->
		<div :class="tops?'navbar':'navbar-top'" v-if="screenWidth>785" >
			<el-tooltip class="item" effect="dark" content="返回首页" placement="left">
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"
					@click="gohome()"><i class="el-icon-s-home"></i>
					<div style="font-size: 14px;">首页</div>
				</a>
			</el-tooltip>
			<div class="qrShow3 right2" v-if="showofficialQR">
				<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
			</div>
			
			<div class="qrShow2 right2" v-if="showserviceQR">
				<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
			</div>
			<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"
				@mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>
				<div style="font-size: 14px;">客服</div>
			</a>
			<div class="qrShow right" v-if="showQR">
				<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
			</div>
			
			<el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
				<a @click="gotop"><i class="el-icon-caret-top"></i>
					<br>
					<span>顶部</span></a>
			</el-tooltip>
		</div>
		<!-- footer -->
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;padding-top:20px;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="item in bottomnav" :key="item" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
			<div class="row" :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'" >
				<!-- <div class="copy-left">
					<p><i class="el-icon-phone-outline"></i>{{pcsetdata.phone}}</p>
					<p><i class="el-icon-message"></i>{{pcsetdata.email}}</p>
					<p style="font-size: 13px;">地址信息：{{pcsetdata.address}}</p>
				</div> -->
				
				<div class="copy-left " :style="screenWidth>785?'':'width:40%;'" >
					<div class="bottom_logo"  v-if="screenWidth>785" >
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					
				</div>
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'" abort="">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>

			</div>
		</div>
	</div>


</template>

<script>
	import {
		getActypes,
		getActivitylist,
		getPc,
		getPlate,
		getbottomnav
	} from '@/request/api'

	export default {
		name: "Activitylist",
		// components: {
		//   navTab
		// },
		data() {
			return {
				bottomnav: [],
				top_search_url: '/Activitylist',
				stitle: '',
				showmsg: '',
				typescount: 0,
				options: [{
					value: '/Activitylist',
					label: '活动搜索'
				}],
				platelist: [],
				activeIndex2: '/Activitylist',
				phoneboxshow: false,
				userInfo: {
					username: "",
					education_name: "",
					role_level: ""
				},
				logintype: true,
				banner: [],
				types: [],
				actlist: [],
				quicklist: [],
				aclist: [],
				newsiconon: '',
				category_id: 0,
				total: 0,
				page_index: 1,
				pcsetdata: {},
				//侧边栏
				showQR: false,
				showserviceQR: false,
				showofficialQR:false,
				tops: false,
				heights: window.innerHeight,
				scrolltop: '',
				//屏幕宽高
				// 屏幕宽度
				screenWidth: window.innerWidth,
				top_bannerWidth:Math.round(window.innerWidth/3.42),
				// 屏幕高度
				screenHeight: window.innerHeight,
				//手机端导航栏
				vannavshow:false,
				manage_url:'/',
				manageoptions:[
					{
					  value: '/',
					  label: '管理入口'
					}, {
					  value: 'https://yxwy.wanjiaxiao.cn/',
					  label: '机构管理后台'
					},
					 {
						value:'http://xh.wanjiaxiao.cn/seeyon/index.jsp',
						 label: '研学OA平台'
					 }
				],
				vannavlist:[
					{
						link:'/Home',
						text:'研学首页'
					},
					{
						link:'/Camplist',
						text:'营地列表'
					},
					{
						link:'/Newslist',
						text:'资讯资讯'
					},
					{
						link:'/Baselist',
						text:'基地列表'
					},
					{
						link:'/Courselist',
						text:'研学课程'
					},
					{
						link:'/Linelist',
						text:'研学线路'
					},
				
					{
						link:'/mentorlist',
						text:'研学导师'
					},
					{
						link:'/expertlist',
						text:'专家团队'
					},
				],
			}
		},
		beforeCreate() {
			const loading = this.$loading({
				lock: true,
				text: '页面载入……',
				// spinner: 'el-icon-loading',
				background: '#ffffff'
			});
		},
		created() {
			this.getpcset()
		},
		mounted() {
			const {
				stitle
			} = this.$route.query;
			this.stitle = stitle || ''
			 window.addEventListener('resize', this.handleResize, true)
			var token = localStorage.getItem('token') || ''
			this.token = token
			this.getPlate()
			this.gettypes()
			this.getlist()
			this.getbottomnav()
			this.getQuicklist()
			window.addEventListener('scroll', this.scrollToTop)

		},
		destroyed() {
			window.removeEventListener('scroll', this.scrollToTop)
		},
		// 销毁监听
		beforeDestroy() {
		  window.removeEventListener('resize', this.handleResize);
		},
	  methods: {
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
		  vanlinkgo(e){
		  		  console.log(e)
		  		  this.$router.push({
		  		    path: e.link,
		  		    name: e.link,
		  		    query: {
		  		    }
		  		  }); 
		  },
		  vannavmenushow(){
		  		this.vannavshow=false  
		  },
		  handleResize() {
		  		   this.top_bannerWidth = 0;
		    this.screenWidth = window.innerWidth;
		  		this.top_bannerWidth=window.innerWidth/3.42
		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
		    this.screenHeight = window.innerHeight;
		  },
			getbottomnav() {
				var data = {
					page_index: 1,
					page_size: 15,
					flag:99
				}
				getbottomnav(data).then(res => {
					this.bottomnav = res.data.data.list
				})
			},
			gobottomnav(type, link) {
				if (type == 1) {
					this.$router.push({
						path: link
					});
				}else if(type==2){
					  window.location.href = link;
				  }
			},
			logout() {
				var that = this
				this.$confirm('是否确认退出登录?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$alert("已退出登录", '', {
						confirmButtonText: '确认',
						callback: action => {
							localStorage.setItem('token', '')
							localStorage.setItem('refreshToken', '')
							that.$router.go(0)
						}
					});
				}).catch(() => {

				});
			},
			showofficialQRCode(){
					 this.showofficialQR=true
			},
			hideofficialQRCode(){//隐藏二维码
			    this.showofficialQR = false
			},
			showserviceQRCode() {
				this.showserviceQR = true
			},
			hideserviceQRCode() { //隐藏二维码
				this.showserviceQR = false
			},
			showQRCode() { //显示二维码
				this.showQR = true
			},
			hideQRCode() { //隐藏二维码
				this.showQR = false
			},
			scrollToTop() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				this.scrolltop = scrollTop
				if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
					this.tops = true
				} else {
					this.tops = false
				}
			},
			gotop() {
				let timer = setInterval(() => {
					document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
					if (this.scrolltop === 0) {
						clearInterval(timer)
					}
				}, 15)
			},
			gotopsearch() {
				this.$router.push({
					path: this.top_search_url,
					name: this.top_search_url,
					query: {
						stitle: this.stitle,
					}
				});
			},
			showstep(ind) {
				this.$refs.carousel.setActiveItem(ind)
			},
			goplate(id) {
				this.modules = id
				this.page_index = 1
				this.getlist()
			},
			getPlate() {
				var data = {
					flag:99
				}
				getPlate(data).then(res => {
					this.platelist = res.data.data
				})
			},
			showphonebox() {
				this.phoneboxshow = true
			},
			showactmsg(id) {
				this.showmsg = id
			},
			closeactmsg(id) {
				this.showmsg = ''
			},
			closephonebox() {
				this.phoneboxshow = false
			},
			goregister(e) {
				this.$router.push({
					path: "/register",
					name: "/register",
					query: {}
				});
			},
			gohome(e) {
				this.$router.push({
					path: "/Home",
					name: "/Home",
					query: {}
				});
			},
			getpcset() {
				var data={
				flag:99
			}
				getPc(data).then(res => {
					this.pcsetdata = res.data.data
				})
			},
			camptypetab(val) {
				this.category_id = val
				this.getlist()
			},
			pagechange(val) {
				this.page_index = val
				this.getlist()
			},
			handleClick(e) {
				console.log(e, this.category_id)
				this._getNewslist()
			},
			onitemopen(index) {
				this.newsiconon = index
			},
			gettypes() {
				var data = {}
				getActypes(data).then(res => {
					if(res.code==200){
					console.log("7890",res.data.data)
					var rdata=res.data
					this.types = rdata.data
					console.log("123222224",this.types.length)
					var len=Number(this.types.length)
					if (len > 8) {
						this.typescount = Number(this.types.length) / 8
					}


					this.category_id=res.data.data[0].id
					this._getNewslist()
					}
					
				}).catch(error => {
					console.error(error);
				});
			},
			getQuicklist() {
				var data = {
					page_index: 1,
					page_size: 5,
				}
				getActivitylist(data).then(res => {
					console.log(res.data)
					this.quicklist = res.data.data.list
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					loading.close();
				}).catch(error => {
					console.error(error);
				});
			},
			getlist() {
				var data = {
					// type:this.camptype,
					title: this.stitle,
					category_id: this.category_id,
					period: this.period,
					page_index: this.page_index,
					page_size: 10,
					modules: this.modules,
				}
				getActivitylist(data).then(res => {
					console.log(res.data)
					this.actlist = res.data.data.list
					this.total = res.data.data.total

					// this.quicklist=res.data.data.list
				}).catch(error => {
					console.error(error);
				});
			},

			handleSelect(key, keyPath) {
				console.log(key, keyPath);
			},
			/*
			 * 查看详情
			 * */
			detail(e) {
				this.$router.push({
					path: "/Activitydetails",
					name: "Activitydetails",
					query: {
						id: e
					}
				});
			},
			gomodules(e){
				if(e){
					window.location.href = e;
				}
			},
		}
	};
</script>

<style scoped>
	.main_box {
		width: 1100px;
		min-height: 600px;
		margin: 0 auto;
	}

	.activitylist_box {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: 20px;
		/* align-items: ; */
	}

	.activity_item {
		width: 520px;
		height: 452px;
		overflow: hidden;
		margin-bottom: 20px;
		position: relative;
	}

	.activity_img:hover+.activity_details {}

	.activity_details_show {
		display: block !important;
		/* 鼠标悬浮时显示盒子*/
		animation: slide-in 1.5s 1;
		/* 播放向右滑动的动画 */
		animation-fill-mode: forwards;
	}

	.activity_details_close {
		animation: slide-off 1s 1;
		/* 播放向右滑动的动画 */
		animation-fill-mode: forwards;
	}

	@keyframes slide-in {
		100% {
			transform: translate(0, 0);
			/* 滑动到目标位置 */
		}
	}

	@keyframes slide-off {
		0% {
			transform: translate(0, 0);
		}

		100% {
			transform: translate(-100%, 0%);
		}
	}

	.activity_img {
		width: 520px;
		height: 312px;
		position: relative;
	}

	.activity_img img {
		width: 100%;
		height: 100%;
	}

	.type_icon {
		width: 65px !important;
		height: 65px !important;
		position: absolute;
		top: -3px;
		left: -3px;
	}

	.activity_details {
		width: 460px;
		height: 272px;
		position: absolute;
		top: 0;
		/* 相对于父元素垂直居中 */
		left: 0;
		/* 左侧距离为0 */
		transform: translate(-100%, 0%);
		/* 水平向左移动一个盒子宽度的距离 */
		padding: 20px 30px;
		background: #FE7C2Be6;
		cursor: pointer;
	}

	.activity_details:hover {
		display: block !important;
		/* 隐藏盒子 */
	}

	.activity_details_top {
		width: 100%;
		height: 180px;
		border-bottom: 1px solid white;
		overflow: hidden;
	}

	.activity_details_title {
		width: 100%;
		text-align: left;
		min-height: 36px;
		line-height: 36px;
		overflow: hidden;
		font-family: "微软雅黑";
		font-size: 20px;
		font-weight: 700;
		color: white;
	}

	.activity_msg {
		width: 100%;
		height: 124px;
		text-align: left;
		margin-top: 10px;
		overflow: hidden;
		line-height: 30px;
		font-family: "微软雅黑";
		font-size: 16px;
		color: white;
	}

	.activity_details_bottom {
		width: 100%;
		height: 72px;
		padding-top: 10px;
	}

	.activity_details_timer {
		display: flex;
		align-items: center;
		width: 100%;
		/* height: 36px; */
		position: relative;
		margin-bottom: 20px;
		/* line-height: 36px; */
		margin-left: 12px;
		font-family: "微软雅黑";
		font-size: 16px;
		color: white;
	}

	.activity_details_buttonbox {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 36px;
		position: relative;
		margin-bottom: 20px;

	}

	.activity_price {
		line-height: 44px;
		font-family: "微软雅黑";
		font-size: 24px;
		color: white;
		margin-right: 8px;

	}

	.activity_details_buttonbox button {
		width: 120px;
		background: white;
		line-height: 38px;
		height: 40px;
		text-align: center;
		border-radius: 2px;
		font-family: "微软雅黑";
		font-size: 18px;
		color: #FE7C2B;
		border: 1px solid #FE7C2B;
	}


	.activity_bottom {
		width: 460px;
		height: 100px;
		padding: 20px 30px;
		background: #ffffff;
		overflow: hidden;
	}

	.activity_title {
		width: 100%;
		text-align: left;
		font-family: "微软雅黑";
		font-size: 20px;
		font-weight: 700;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		color: #606266;
		margin-bottom: 10px;

	}

	.Organizer {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.camp_img {
		width: 60px;
		height: 60px;
	}

	.camp_img img {
		width: 100%;
		height: 100%;
		border-radius: 999px;
	}

	.Organizer_msg {
		width: 384px;
		height: 60px;

	}

	.Organizer_unit {
		width: 100%;
		text-align: left;
		font-family: "微软雅黑";
		font-size: 18px;
		font-weight: 400;
		color: #303133;
		height: 30px;
		line-height: 30px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.Organizer_subtitle {
		width: 100%;
		text-align: left;
		font-family: "微软雅黑";
		font-size: 16px;
		font-weight: 400;
		color: #909399;
		height: 30px;
		line-height: 30px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.next {
		text-align: left;
		color: #FE7C2B;
	}

	.newslist_box {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.newslist {
		width: 790px;
		background: #fff;
		margin: 20px;
		margin-left: 0px;
		padding: 10px;
	}

	.textmsg {
		width: 388px;
		padding-top: 12px;
		/* height: 78px; */
		font-size: 16px;
		text-align: left;
		color: #818181;
		line-height: 1.6;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
	}

	.newsitem {
		width: 720px;
		margin: 0px 10px;
		padding: 20px 0px;
		border-bottom: 1px dashed #dadada;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.newsimg {
		width: 280px;
		height: 180px;
		margin-right: 20px;
	}

	.newsimg img {
		width: 100%;
		height: 100%;
	}

	.newsmsg {
		width: 388px;
		height: 160px;
		/* padding: 20px 0px; */
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.newstitle {
		font-weight: 400;
		font-size: 24px;
		color: #333;
		/* margin-bottom: 15px; */
		text-align: left;
		/* height: 50px; */
		/* line-height: 50px; */
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.newstitle:hover {
		color: #FE7C2B;
	}

	.author {
		text-align: left;
	}

	.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
		color: #FE7C2B;
	}

	.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
		color: #FE7C2B;
	}

	.el-tabs__item {
		font-size: 18px;
		height: 60px;
		line-height: 60px;
		/* padding:30px ; */
	}

	.el-tabs--border-card .el-tabs__header {
		background-color: #ffffff;
	}

	.news_bottom {
		font-size: 14px;
		color: #999;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.pages_total {
		padding: 20px;
		padding-bottom: 0px;

	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #FE7C2B;
	}

	/* 快速资讯内容 */
	.quicknewslist {
		width: 395px;
		background-color: #ffffff;
		margin-top: 20px;
		border: 1px solid #DCDFE6;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
	}

	.quick_title {
		padding: 20px 0px;
		background: #fff;
		border-bottom: 2px solid #f8f8f8;
		font-size: 20px;
		color: #333;
		font-weight: 400;
	}

	.quicknews {
		padding: 20px;
	}

	.quick_items {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin: 20px 0px;

	}

	.quick_items i {
		margin-right: 10px;
	}

	.quick_items img {
		width: 120px;
		height: 77px;
		/* margin-left: 10px; */
		margin-right: 10px;
		background-color: #333;
	}

	.quick_text {
		/* width: 100%; */
		width: 180px;
		font-size: 16px;
		font-weight: 400;
		color: #333;
		line-height: 1.5 !important;
		white-space: normal;

		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.quick_text2 {
		/* color: #333; */
		width: 180px;
		font-size: 16px;
		font-weight: 400;
		color: #FE7C2B;
		white-space: normal;
		line-height: 1.5 !important;
		/* 		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap; */
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;

	}

	.quick_pay {
		width: 180px;
		text-align: left;
		margin-top: 5px;
		font-size: 12px;
		color: rgb(245, 108, 108);
	}


	.screen_box {
		/* margin-top: 30px; */
		background: #fff;
		border: 1px solid #e9e9e9;
		border-bottom: 0;
		width: 100%;
		/* box-shadow: 0 2px 18px 0 rgba(0,0,0,.1); */
	}

	.screen_items {
		width: 100%;
		display: flex;
		align-items: center;
		/* padding-left: 134px; */
		border-bottom: 1px solid #e9e9e9;

	}

	.screen_title {
		width: 120px;
		padding: 19px 0;
		text-align: center;
		background: #f4f4f4;
	}

	.screen_item {
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		height: 34px;
		line-height: 34px;
		text-align: center;
	}

	.screen_item_a {
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		height: 34px;
		line-height: 34px;
		text-align: center;
		background: #FE7C2B;
		color: #fff;
	}

	.screen_item:hover {
		background: #FE7C2B;
		color: #fff;
	}


	.screen_box {
		margin-top: 30px;
		background: #fff;
		border: 1px solid #e9e9e9;
		border-bottom: 0;
		width: 100%;

	}

	.screen_items {
		width: 1100px;
		display: flex;
		flex-wrap: wrap;
		/* white-space: nowrap; */
		align-items: flex-start;
		/* overflow: scroll;   */
		overflow: auto;
		white-space: nowrap;
		overflow-x: auto;
		overflow-y: hidden;

		/* padding-left: 134px; */


		border-bottom: 1px solid #e9e9e9;

	}

	.screen_title_box {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
	}

	.screen_title {
		width: 120px;
		padding: 19px 0;
		text-align: center;
		background: #f4f4f4;
		flex-shrink: 0;
		flex-basis: auto;
		flex-grow: 0;
		display: inline-block;
	}

	.screen_item {
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		height: 34px;
		line-height: 34px;
		text-align: center;
		flex-shrink: 0;
		flex-basis: auto;
		flex-grow: 0;
		display: inline-block;
	}

	.screen_item_a {
		width: 100px;
		margin: 13px 0 13px 15px;
		cursor: pointer;
		height: 34px;
		line-height: 34px;
		text-align: center;
		background: #FE7C2B;
		color: #fff;
		flex-shrink: 0;
		flex-basis: auto;
		flex-grow: 0;
		display: inline-block;

	}

	.screen_item:hover {
		background: #FE7C2B;
		color: #fff;
	}
</style>